(ns hai.ui.components.new-design.button
  #?(:cljs (:require-macros hai.ui.components.new-design.button))
  (:require
   [clojure.string :as str]
   [lambdaisland.ornament :as o]
   [hai.ui.components.new-design.typography :as typography]
   [hai.ui.components.new-design.utils :refer [px->rem]]
   [hai.ui.tokens :as t]))

(def button-border (str "solid 2px " t/--hai-dark-purple))

(o/defstyled big :span
  {:gap "6px"
   :padding (str/join " " [(px->rem 11) (px->rem 24)])
   :border-radius (px->rem 10)})

(o/defstyled component* :button
  :flex :flex-row
  {:width "fit-content"}
  :cursor-pointer
  :items-center :justify-center
  :whitespace-nowrap
  ([{:keys [icon text on-click title]}]
   [:<>
    {:on-click on-click
     :title title}
    icon
    text]))

(o/defstyled light component*
  typography/text
  {:border button-border
   :color t/--hai-dark-purple}
  [:& [:svg {:fill t/--hai-dark-purple}]])

(o/defstyled component :button
  component*
  big
  light
  ([{:keys [icon text on-click title]}]
   [:<>
    {:on-click on-click
     ;; TODO doesn't work
     :title title}
    icon
    text]))

(o/defstyled dark component*
  {:font-size (px->rem 20)
   :font-weight "700"
   :line-height (px->rem 22.4)}
  {:border (str "solid 2px " t/--hai-purple-2)
   :background-color t/--hai-purple-2
   :color t/--hai-white-1}
  [:& [:svg {:fill t/--hai-white-1}]])

(o/defstyled warning component*
  {:border (str "solid 2px " t/--colour-rasberry)
   :background-color t/--colour-rasberry
   :color t/--hai-white-1})

(o/defstyled disabled component*
  {:border (str "solid 2px " t/--charcoal-10)
   :background-color t/--charcoal-10
   :color t/--text-secondary-40})

(o/defstyled small component*
  {:gap "6px"
   :padding (str/join " " [(px->rem 4) (px->rem 10)])
   :font-size (px->rem 16)
   :font-weight "600"
   :border-radius (px->rem 10)})

;; TODO this is a hack
(o/defstyled light-small component*
  light
  small)

(o/defstyled dark-small component*
  dark
  small)

(o/defstyled dark-small-disabled component*
  disabled
  small)

(o/defstyled dark-big component*
  dark
  big)
